import React, { useState } from 'react'
import { get } from 'lodash'
import PropTypes from 'prop-types'

import View from '../../components/bantrab/view'
import Header from '../../components/bantrab/blog/listing/header'
import List from '../../components/bantrab/blog/listing/list'
import Breadcrumb from '../../components/bantrab/blog/listing/breadcrumb'

import { getBaseViewInfo } from '../../components/bantrab/view/functions'
import { getPage, getNews } from '../../api/bantrab'
import { NEWS_LIST_QUERY as ITEMS_LIST_QUERY } from '../../api/bantrab/queries'

const INDEX_TYPE = 'news.NewsIndexPage'
const ITEMS_PER_PAGE = parseInt(process.env.NEXT_PUBLIC_BANTRAB_NEWS_PER_PAGE_ON_LISTING)

async function getServerSideProps () {
  const { head, navbar, footer, raw } = await getBaseViewInfo()

  const indexPages = raw.rootChildrenPages.items.filter(page => page.meta.type === INDEX_TYPE)
  const indexPageId = indexPages[0].id

  let indexPage = await getPage(indexPageId, { fields: '*' })
  indexPage = await indexPage.json()

  let items = await getNews({
    ...ITEMS_LIST_QUERY,
    limit: ITEMS_PER_PAGE
  })
  items = await items.json()

  const body = [
    {
      type: 'header',
      value: {
        preTitle: indexPage.headerPreTitle,
        title: indexPage.headerTitle,
        image: indexPage.headerImage
      }
    },
    {
      type: 'news',
      value: {
        news: items
      }
    }
  ]

  return {
    props: {
      head,
      navbar,
      body,
      footer
    }
  }
}

const Home = ({ head, navbar, body, footer }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [innerNews, setInnerNews] = useState(body[1].value.news)

  const fetchNews = async _ => {
    setIsLoading(true)

    const offset = get(innerNews, 'items', []).length
    let fetchedNews = await getNews({
      ...ITEMS_LIST_QUERY,
      offset: offset,
      limit: ITEMS_PER_PAGE
    })
    fetchedNews = await fetchedNews.json()

    const updatedNews = { ...innerNews }
    updatedNews.meta = {
      ...updatedNews.meta,
      ...fetchedNews.meta
    }

    updatedNews.items = updatedNews.items.concat(fetchedNews.items)
    setInnerNews(updatedNews)
  }

  return <View
    {...{ head, navbar, footer }}>
    {
      body.map((section, index) => {
        if (section.type === 'header') {
          return <Header
            key={index}
            id={section.type}
            order={index}
            {...section.value}
          />
        }
        if (section.type === 'news') {
          return <List
            key={index}
            id={section.type}
            order={index}
            fetchNews={fetchNews}
            {...section.value}
            {...innerNews}
          />
        }
        return null
      })
    }
    <Breadcrumb />
  </View>
}

Home.propTypes = {
  head: PropTypes.object,
  navbar: PropTypes.object,
  body: PropTypes.array,
  footer: PropTypes.object
}

export { getServerSideProps }
export default Home
